import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/shared/services/shared-service/shared.service';

export const EditComponentGuard = (): boolean => {
  const router: Router = inject(Router);
  const sharedService = inject(SharedService);
  const isProfileLocked = sharedService.isProfileLocked;

     return true;
};
